__turbopack_context__.v({
  "buttonsWrapper": "AM8hLq_buttonsWrapper",
  "checkIcon": "AM8hLq_checkIcon",
  "customLabel": "AM8hLq_customLabel",
  "emailSentDescription": "AM8hLq_emailSentDescription",
  "emailSentHeader": "AM8hLq_emailSentHeader",
  "formHeader": "AM8hLq_formHeader",
  "formWrapper": "AM8hLq_formWrapper",
  "hasAccount": "AM8hLq_hasAccount",
  "row": "AM8hLq_row",
});
